import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../api";
import Button from "../../components/Button";
import { LoaderContext } from "../../context/LoaderContext";
import {
  StyledEmptyDataContainer,
  StyledMainContainer,
  StyledTableContainer,
} from "../../styles/global";
import { ShortUrl } from "../../types/interfaces";
import { StyledURLListContainer, StyledURLListTableHeader } from "./styled";
import { GoPlus } from "react-icons/go";
import Header from "../../components/Header";
import URLTable from "../../components/URLTable";

interface Props {}

const URLList: React.FC<Props> = () => {
  const { showLoader } = useContext(LoaderContext);
  const [links, setLinks] = useState<ShortUrl[] | null>(null);

  const navigate = useNavigate();

  const FetchLinks = async () => {
    showLoader({
      show: true,
    });
    api
      .FetchLinks()
      .then((res) => {
        setLinks(res.data.data);
      })
      .catch((err) => {
        toast.error(err.response?.data?.message || "Something went wrong");
      })
      .finally(() => {
        showLoader({
          show: false,
        });
      });
  };

  useEffect(() => {
    FetchLinks();
  }, []); // eslint-disable-line

  if (!links) {
    return null;
  }

  return (
    <>
      <Header title="WhatQR" />

      <StyledMainContainer>
        <StyledURLListContainer>
          <StyledURLListTableHeader>
            <h2>All Short URLs</h2>

            <Button
              icon={<GoPlus />}
              label="Create short URL"
              style={{
                marginBottom: "16px",
                float: "right",
              }}
              onClick={() => {
                navigate("/generate/url");
              }}
            />
          </StyledURLListTableHeader>

          {links.length > 0 ? (
            <StyledTableContainer>
              <URLTable
                data={links}
                onEdit={(url: ShortUrl) => {}}
                onDelete={(url: ShortUrl) => {}}
              />
            </StyledTableContainer>
          ) : (
            <StyledEmptyDataContainer>
              <p>No URLs added</p>
            </StyledEmptyDataContainer>
          )}
        </StyledURLListContainer>
      </StyledMainContainer>
    </>
  );
};

export default URLList;
